import {NgModule, LOCALE_ID} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import locale from '@angular/common/locales/it';
import {BrowserModule, Title} from '@angular/platform-browser';
import {ServiceWorkerModule} from '@angular/service-worker';
import {FaIconLibrary} from '@fortawesome/angular-fontawesome';
import {NgxWebstorageModule} from 'ngx-webstorage';
import dayjs from 'dayjs/esm';
import {NgbDateAdapter, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import {ApplicationConfigService} from 'app/core/config/application-config.service';
import './config/dayjs';
import {SharedModule} from 'app/shared/shared.module';
import {TranslationModule} from 'app/shared/language/translation.module';
import {AppRoutingModule} from './app-routing.module';
import {HomeModule} from './home/home.module';
import {NgbDateDayjsAdapter} from './config/datepicker-adapter';
import {fontAwesomeIcons} from './config/font-awesome-icons';
import {MainComponent} from './layouts/main/main.component';
import {NavbarComponent} from './layouts/navbar/navbar.component';
import {PageRibbonComponent} from './layouts/profiles/page-ribbon.component';
import {ActiveMenuDirective} from './layouts/navbar/active-menu.directive';
import {ErrorComponent} from './layouts/error/error.component';
import {HeaderComponent} from './layouts/header/header.component';
import {FooterComponent} from './layouts/footer/footer.component';
import {ReactiveFormsModule} from "@angular/forms";
import {
  SceltaDataOraPrenotazioneComponent
} from "./appuntamenti/scelta-data-ora-prenotazione/scelta-data-ora-prenotazione.component";
import {ListaPrenotazioniComponent} from "./appuntamenti/lista-prenotazioni/lista-prenotazioni.component";
import {
  InserimentoDatiPrenotazioneComponent
} from "./appuntamenti/inserimento-dati-prenotazione/inserimento-dati-prenotazione.component";
import {
  SceltaServiziPrenotazioneComponent
} from "./appuntamenti/scelta-servizi-prenotazione/scelta-servizi-prenotazione.component";
import {
  RiepilogoPrenotazioneComponent} from "./appuntamenti/riepilogo-prenotazione/riepilogo-prenotazione.component";
import {FullCalendarModule} from "@fullcalendar/angular";
import {AutocertificazioniComponent} from './autocertificazioni/autocertificazioni/autocertificazioni.component';
import {NavbarService} from "./services/navbar.service";
import {
  PrenotaNuovoAppuntamentoComponent
} from "./appuntamenti/prenota-nuovo-appuntamento/prenota-nuovo-appuntamento.component";
import {UserComponent} from "./settings/user/user.component";
import {ContenutiLegaliComponent} from "./settings/contenuti-legali/contenuti-legali.component";
import {JoyrideModule} from 'ngx-joyride';
import {
  AutocertificazioniEmesseComponent
} from './autocertificazioni/autocertificazioni-emesse/autocertificazioni-emesse.component';
import {DettaglioAppuntamentoComponent} from './appuntamenti/dettaglio-appuntamento/dettaglio-appuntamento.component';
import {DynamicFormRenderModule} from "dmidynamic-form-render";
import {NuovaIstanzaComponent} from './tributi/nuova-istanza/nuova-istanza.component';
import {IstanzeEmesseComponent} from './tributi/istanze-emesse/istanze-emesse.component';
import {IntegrazioneComponent} from './tributi/integrazione/integrazione.component';
import { DragDropDirective } from './directives/drag-drop.directive';
import { PagamentoComponent } from './tributi/pagamento/pagamento.component';
import { MessageSettingsComponent } from './settings/message-settings/message-settings.component';
import {HeaderService} from "./services/header-service.service";
import { DettaglioIstanzaComponent } from './tributi/dettaglio-istanza/dettaglio-istanza.component';
import { RatingComponent } from './layouts/rating/rating.component';
import { QuestionComponent } from './layouts/question/question.component';
import { GestionePreferitiComponent } from './settings/gestione-preferiti/gestione-preferiti.component';
import { PagamentoTributiComponent } from './tributi/pagamento-tributi/pagamento-tributi.component';
import { DettaglioPagamentoTributiComponent } from './tributi/pagamento-tributi/dettaglio-pagamento-tributi/dettaglio-pagamento-tributi.component';
import {NgxPaginationModule} from "ngx-pagination";
import { LandingModule } from './landing/landing.module';
import { InformativaPrivacyComponent } from './tributi/informativa-privacy/informativa-privacy.component';
import { RichiestaInviataComponent } from './tributi/richiesta-inviata/richiesta-inviata.component';
import { ListaPagamentiComponent } from './tributi/lista-pagamenti/lista-pagamenti.component';
import { AreapersonaleComponent } from './entities/areapersonale/areapersonale.component';
import { IntegrazionePagamentiComponent } from './tributi/integrazione-pagamenti/integrazione-pagamenti.component';
import { PagamentoTerminatoComponent } from './tributi/pagamento-tributi/pagamento-terminato/pagamento-terminato.component';
@NgModule({
  imports: [
    BrowserModule,
    SharedModule,
    HomeModule,
    LandingModule,
    // jhipster-needle-angular-add-module JHipster will add new module here
    AppRoutingModule,
    // Set this to true to enable service worker (PWA)
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: false}),
    HttpClientModule,
    NgxWebstorageModule.forRoot({prefix: 'jhi', separator: '-', caseSensitive: true}),
    TranslationModule,
    ReactiveFormsModule,
    FullCalendarModule,
    JoyrideModule.forRoot(),
    DynamicFormRenderModule,
    NgxPaginationModule
  ],
  providers: [
    Title,
    {provide: LOCALE_ID, useValue: 'it'},
    {provide: NgbDateAdapter, useClass: NgbDateDayjsAdapter},
    {provide: HTTP_INTERCEPTORS, useClass: MainComponent, multi: true},
    NavbarService,HeaderService
  ],

  declarations: [MainComponent, NavbarComponent, ErrorComponent, PageRibbonComponent,
    ActiveMenuDirective, HeaderComponent, FooterComponent,
    UserComponent,
    ContenutiLegaliComponent, ListaPrenotazioniComponent,
    InserimentoDatiPrenotazioneComponent, SceltaServiziPrenotazioneComponent, RiepilogoPrenotazioneComponent, SceltaDataOraPrenotazioneComponent,
    PrenotaNuovoAppuntamentoComponent, AutocertificazioniComponent, AutocertificazioniEmesseComponent,
    DettaglioAppuntamentoComponent, NuovaIstanzaComponent,
    IstanzeEmesseComponent, IntegrazioneComponent, DragDropDirective, PagamentoComponent, MessageSettingsComponent, DettaglioIstanzaComponent, RatingComponent, QuestionComponent, GestionePreferitiComponent, PagamentoTributiComponent, DettaglioPagamentoTributiComponent, PagamentoTerminatoComponent, InformativaPrivacyComponent, RichiestaInviataComponent, ListaPagamentiComponent, AreapersonaleComponent, IntegrazionePagamentiComponent],
  bootstrap: [MainComponent],
    exports: []
})
export class AppModule {
  constructor(applicationConfigService: ApplicationConfigService, iconLibrary: FaIconLibrary, dpConfig: NgbDatepickerConfig) {
    applicationConfigService.setEndpointPrefix(SERVER_API_URL);
    registerLocaleData(locale);
    iconLibrary.addIcons(...fontAwesomeIcons);
    dpConfig.minDate = {year: dayjs().subtract(100, 'year').year(), month: 1, day: 1};
  }
}
